module.exports = __webpack_public_path__ + "48e4e2745509148a6551407a7fdd424d.pdf";